<ng-container>
  <div id="safe-harbor" class="container-gray">
    <div class="row">
      <div class="col-xs-12"></div>
      <h3 *ngIf="processedDistribution?.Type !== 'Safe Harbor'">
        Retirement Documents (SPD, SMM) - Distribution Confirmation
      </h3>
      <h3 *ngIf="processedDistribution?.Type === 'Safe Harbor'">
        Safe Harbor - Distribution Confirmation
      </h3>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="vspacer vspacer-lg"></div>
        <table id="acknowledgements" class="table">
          <tbody class="printDist">
            <tr class="active expanded">
              <td>{{ processedDistribution?.Organization | uppercase }}</td>
              <td>{{ processedDistribution?.PlanDocument }}</td>
              <td>{{ processedDistribution?.Type }}</td>
              <td>{{ processedDistribution?.EffectiveDateDisplay }}</td>
            </tr>
            <tr class="dist-details">
              <td colspan="4">
                <div class="row">
                  <div class="col-xs-12">
                    <h3 class="confirmation-message">
                      <span
                        class="glyphicon glyphicon-ok-sign text-success pull-left"
                      ></span>
                      <span class="text-success"
                        >Your distribution acknowledgment was successfully submitted on
                        {{ processedDistribution?.SubmissionDate }} by {{processedDistribution?.SubmittedByFullName}}.</span
                      >
                    </h3>
                    <div class="vspacer vspacer-large"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <h4>401(k) Plan</h4>
                    <p>
                      Organization:
                      {{ processedDistribution?.Organization | uppercase }}
                      <br />
                      Document Type: {{ processedDistribution?.Type }}
                    </p>
                    <br />
                    <h5>DISTRIBUTION DETAILS</h5>
                    <p>
                      Date Distributed:
                      {{
                        processedDistribution?.DistributionDate
                          | date : "MM/dd/yyyy"
                      }}
                      <br />
                      Method of Distribution:
                      {{ processedDistribution?.DistributionMethod }}
                      <br />
                      Comments:
                      {{
                        processedDistribution?.Comments
                          ? processedDistribution.Comments
                          : "N/A"
                      }}
                    </p>
                    <div *ngIf="processedDistribution?.ParticipantNumber > 0">
                      <h5>NON-ENGLISH LANGUAGE SURVEY</h5>
                      <div>
                        <div
                          *ngIf="
                            processedDistribution?.FewerThan100Participants &&
                            processedDistribution?.ParticipantNumber < 100
                          "
                        >
                          <b> Plans with fewer than 100 participants</b>
                          <div>
                            Are 25% or more of all plan participants only
                            literate in a non-English language?
                            {{
                              processedDistribution?.English25Percent
                                ? "Yes"
                                : "No"
                            }}
                          </div>
                          <div
                            *ngIf="
                              !processedDistribution?.English25Percent &&
                              (!processedDistribution?.MoreThan100Participants ||
                                (processedDistribution?.MoreThan100Participants &&
                                  processedDistribution?.English500))
                            "
                          >
                            A non-English survey is not required.
                          </div>
                          <div *ngIf="processedDistribution?.English25Percent">
                            <div>
                              Total number of plan participants who read only
                              the same non-English language:
                              {{ processedDistribution?.NumParticipantsLesser }}
                            </div>
                            <div>
                              What is the non-English language?
                              {{
                                processedDistribution?.NonEnglishLanguageLesser
                              }}
                            </div>
                          </div>
                        </div>
                        <br />
                        <div
                          *ngIf="
                            processedDistribution?.MoreThan100Participants &&
                            processedDistribution?.ParticipantNumber > 99
                          "
                        >
                          <b> Plans with 100 or more participants</b>
                          <div>
                            Are 500 or more of your plan participants literate
                            only in a non-English language?
                            {{
                              processedDistribution?.English500 ? "Yes" : "No"
                            }}
                          </div>
                          <div *ngIf="!processedDistribution?.English500">
                            A non-English survey is not required.
                          </div>
                          <div *ngIf="processedDistribution?.English500">
                            <div>
                              Are 10% or more of your plan participants literate
                              only in a non-English language?
                              {{
                                processedDistribution?.English10Percent
                                  ? "Yes"
                                  : "No"
                              }}
                            </div>
                            <div>
                              Total number of plan participants who read only
                              the same non-English language:
                              {{ processedDistribution?.NumParticipantsMore }}
                            </div>
                            <div>
                              What is the non-English language?
                              {{
                                processedDistribution?.NonEnglishLanguageMore
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>
